import { ButtonActions } from "../../../app.constants";
import { DocumentPersonneAvertie } from "./document-pa.entity";

export class StepAction {

	documentPa!: DocumentPersonneAvertie | null;
	buttonAction!: ButtonActions;
	
	constructor(documentPa: DocumentPersonneAvertie | null, buttonAction: ButtonActions) {
		this.documentPa = documentPa;
		this.buttonAction = buttonAction;
	}

}